/**
 * _calc_concrete.js — browser mirror of application/utils/calculators/concrete.py.
 *
 * Python owns the formula and the cited bag yield; this repeats them for an
 * instant answer. Change both, and tests/fixtures/calculator_cases.json, together.
 */

import { plainNumber, roundHalfUp, roundUp } from "./_calc_math.js";

const BAG_YIELD_M3 = 0.45 * 0.5 * 0.075 / 2;
const BAGS_UP_TO_M3 = 0.5;

function volume(v) {
    if (v.shape === "footing") {
        return v.footing_length * (v.footing_width / 1000) * (v.footing_depth / 1000);
    }
    if (v.shape === "holes") {
        const radius = v.hole_diameter / 2000;
        return v.holes * Math.PI * radius * radius * (v.hole_depth / 1000);
    }
    return v.length * v.width * (v.thickness / 1000);
}

export function calculate(v) {
    const net = volume(v);
    const order = net * (1 + v.wastage / 100);
    const bags = Math.ceil(roundHalfUp(order / BAG_YIELD_M3, 6));
    const readyMix = roundUp(order, 1);
    const item = order <= BAGS_UP_TO_M3
        ? { description: "Concrete mix, 20 kg bags", quantity: bags }
        : { description: `Ready-mix concrete, ${plainNumber(readyMix)} m3 delivered`,
            quantity: readyMix };
    return {
        outputs: {
            net_volume: roundHalfUp(net, 3),
            order_volume: roundHalfUp(order, 2),
            bags,
            ready_mix: readyMix,
        },
        items: net > 0 ? [item] : [],
        warnings: [],
    };
}
